const $ = require('jquery');
const CandidateTemplate = require('./candidates.hbs');
const Modal = require('../common/modal');
const WrDetailModal = require('../common/wrdetail-modal');
const siteUrl = require('../common/site-url');
const querySelect = require('../common/query-select');
const axios = require('../common/axios');
const Toast = require('../common/toast');
const EditAssignmentTemplate = require('./edit-assignment.hbs');
const {FormValidator} = require('../common/form-validator');
const SendInvitiationsTemplate = require('./send-invitations.hbs');

if (!Array.isArray) {
	Array.isArray = function (vArg) {
		return Object.prototype.toString.call(vArg) === "[object Array]";
	};
}

function EinsatzPlaner(teamId, numberOfJudges, countOfAssignments, cancelled, readonly) {
	const {candidateContainer, progress, modalEditAssignment, modalSendInvitations} = readonly ? {
		candidateContainer: null,
		progress: null,
		modalEditAssignment: null,
		modalSendInvitations: null
	} : querySelect({
		candidateContainer: '#_candidate_container',
		progress: '#progress-candidate-list',
		modalEditAssignment: '#dialogEditAssignment',
		modalSendInvitations: '#dialogSendInvitations'
	});

	function getQueryOptions() {
		const {freigabe, verfuegbar, lizenz, doppel, mandant, mandantAuswahl, herkunft, ltvAuswahl} = querySelect({
			freigabe: 'input[name=q_freigabe]:checked',
			verfuegbar: 'input[name=q_verf]:checked',
			lizenz: 'input[name=q_liz]:checked',
			doppel: 'input[name=q_clubs]:checked',
			mandant: 'input[name=q_mandator]:checked',
			mandantAuswahl: 'select[name=man_mandator]',
			herkunft: 'input[name=q_herkunft]:checked',
			ltvAuswahl: 'select[name=man_ltv]'
		});

		return {
			lizenz: lizenz.value,
			verfuegbar: verfuegbar.value,
			herkunft: herkunft.value === 'man' ? Array.from(ltvAuswahl.querySelectorAll('option:checked')).map(element => element.value) : herkunft.value,
			doppelvermeiden: doppel.value,
			freigabe: freigabe.value,
			mandant: mandant.value === 'man' ? Array.from(mandantAuswahl.querySelectorAll('option:checked')).map(element => element.value) : mandant.value,
		}
	}

	function addQueryOptionsEventHandlers() {
		document.querySelectorAll('.candidate-query-form input[type=radio]').forEach(radio => {
			radio.addEventListener('click', () => {
				if (radio.name === 'q_mandator' || radio.name === 'q_herkunft') {
					if (radio.value !== 'man') {
						loadCandidates(true);
					}
				} else {
					loadCandidates(true);
				}
			})
		});
		document.querySelectorAll('.candidate-query-form select').forEach(select => {
			$(select).change(() => loadCandidates(true))
		});
	}

	function checkAssignmentCount() {
		if (countOfAssignments < numberOfJudges) {
			return Promise.resolve(true);
		}

		return new Promise((resolve, reject) => {
			Modal.create('#dialogMaxWr', {
				onClose: () => {
					return resolve(false);
				},
				onConfirm: () => {
					return resolve(true);
				}
			})
		});
	}

	function clearCandidates() {
		candidateContainer.innerHTML = '';
	}

	function showIndicator() {
		progress.classList.remove('hidden');
		return Promise.resolve();
	}

	function hideIndicator() {
		progress.classList.add('hidden');
	}

	function init() {
		addQueryOptionsEventHandlers();
		loadCandidates();
	}

	function buildQueryString() {
		return Object.entries(getQueryOptions()).reduce(function (prev, [key, value]) {
			if (Array.isArray(value)) {
				prev = prev.concat(value.map(v => `${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(v)}`))
			} else {
				prev.push(`${key}=${encodeURIComponent(value)}`);
			}
			return prev;
		}, []).join('&');
	}

	function loadCandidates(clear) {
		if (clear) {
			clearCandidates();
		}

		const queryString = buildQueryString();

		const base = window.localStorage.getItem('FEATURE_LEGACY_KS') ? 'api/zwe/kandidaten' : 'next/api/ep/kandidaten';

		return showIndicator().then(
			() => axios.get(siteUrl([base, teamId], queryString))
		).then(
			(response) => candidateContainer.innerHTML = CandidateTemplate((response.data || []).map(item => ({...item, status: {...item.status, eingesetztOrAbgesagt: item.status.eingesetzt || item.status.abgesagt}})))
		).catch(
			(error) => {
				console.error('could not load candidates', {error});
				Toast.add('error', 'Kandidaten konnten nicht geladen werden.')
			}
		).finally(
			() => hideIndicator()
		);
	}

	if (!cancelled && !readonly) {
		init();
	}

	let detailModal;

	function selectContainers(invited, wr, doc) {
		return querySelect({
			[invited]: '#_invited_container',
			[wr]: '#_wr_container'
		}, doc)
	}

	function updateCountOfAssignments() {
		countOfAssignments = document.querySelectorAll('#_invited_container .mat-icon.question_mark').length
			+ document.querySelectorAll('#_invited_container .mat-icon.check').length
			+ document.querySelectorAll('#_wr_container > div').length;
	}

	function updateContainers(team) {
		const {invitedCurrent, wrCurrent} = selectContainers('invitedCurrent', 'wrCurrent', document);

		return axios.get(siteUrl(['zwe/einsatzplanen', team]), {responseType: 'document'}).then(
			(response) => {
				const {invitedNew, wrNew} = selectContainers('invitedNew', 'wrNew', response.data);
				invitedCurrent.replaceWith(document.adoptNode(invitedNew));
				wrCurrent.replaceWith(document.adoptNode(wrNew));
				updateCountOfAssignments();
			}
		)
	}

	function toggleCheckboxes(enable) {
		document.querySelectorAll('.einsatz-toggle').forEach((check) => check.disabled = !enable)
	}

	function handleToggleAssignment(add, id, event) {
		const request = {
			team: teamId,
			wertungsrichter: {
				typ: 'intern',
				id: id
			}
		};

		if (add) {
			checkAssignmentCount().then(
				(proceed) => {
					if (proceed) {
						showIndicator().then(
							() => toggleCheckboxes(false)
						).then(
							() => axios.post(siteUrl(['next/api/ep/einsatz']), request)
						).catch(
							(error) => {
								console.error('could not add assignment', {error});
								Toast.add('error', 'Einsatz konnte nicht hinzugefügt werden.')
							}
						).then(
							() => updateContainers(teamId)
						).then(
							() => loadCandidates(true)
						).finally(
							() => {
								toggleCheckboxes(true);
								hideIndicator();
							}
						)
					} else {
						event.preventDefault();
					}
				}
			);
		} else {
			showIndicator().then(
				() => toggleCheckboxes(false)
			).then(
				() => axios.delete(siteUrl(['next/api/ep/einsatz', id]))
			).catch(
				(error) => {
					console.error('could not remove assignment', {error});
					Toast.add('error', 'Einsatz konnte nicht gelöscht werden.')
				}
			).then(
				() => updateContainers(teamId)
			).then(
				() => loadCandidates(true)
			).finally(
				() => {
					toggleCheckboxes(true);
					hideIndicator();
				}
			)
		}
	}

	function allowedChanges(state) {
		if (state === 0) {
			return [
				{mode: 'zusage-erfassen', label: 'Zusage erfassen', selected: true}
			];
		} else if (state === 1) {
			return [
				{mode: 'zusage-erfassen', label: 'Zusage erfassen', selected: true},
				{mode: 'absage-erfassen', label: 'Absage erfassen', selected: false},
				{mode: 'einsatz-loeschen', label: 'Einsatz absagen und löschen', selected: false},
			];
		} else if (state === 2) {
			return [
				{mode: 'absage-erfassen', label: 'Absage erfassen', selected: true},
				{mode: 'einsatz-loeschen', label: 'Einsatz absagen und löschen', selected: false},
			];
		} else if (state === -1) {
			return [
				{mode: 'zusage-erfassen', label: 'Zusage erfassen', selected: true},
				{mode: 'absage-loeschen', label: 'Absage löschen', selected: false}
			]
		} else {
			return [];
		}
	}

	const RemarkTemplates = [
		{
			key: 'fehlendeRueckmeldung',
			label: 'fehlende Rückmeldung',
			text: 'Sie haben sich auf die Einladung zum diesem Wertungsrichtereinsatz nicht rechtzeitig zurückgemeldet. Bitte haben Sie Verständnis, dass wir dies als Absage betrachten müssen.',
			modes: [
				(mode, stateCode) => stateCode === 1 && mode === 'einsatz-loeschen'
			]
		},
		{
			key: 'absageVeranstaltung',
			label: 'Absage der Veranstaltung',
			text: 'Leider müssen wir diesen Wertungsrichtereinsatz absagen, da die gesamte Turnierveranstaltung ausfällt. Wir bitten um Ihr Verständnis.',
			modes: [
				'einsatz-loeschen'
			]
		},
		{
			key: 'fehlerEinsatzplanung',
			label: 'Fehler bei Einsatzplanung',
			text: 'Bei der Einsatzplanung ist uns ein Fehler unterlaufen. Wir bitten um Ihr Verständnis.',
			modes: [
				'einsatz-loeschen'
			]
		}
	];

	function filterRemarkTemplates(mode, stateCode) {
		return RemarkTemplates.filter((template) => {
			return template.modes.map(item => {
				if (typeof item === 'function') {
					return item(mode, stateCode);
				} else {
					return item === mode
				}
			}).filter(value => value).length > 0;
		});
	}

	function editAssignmentFormValidityChanged(valid) {
		document.querySelectorAll('#dialogEditAssignment [data-confirm-modal]').forEach(
			confirm => {
				confirm.disabled = !valid;
			}
		)
	}

	function updateAssigment(id, model) {
		axios.put(siteUrl(['next/api/ep/einsatz', id]), model).then(
			(response) => {
				Toast.add('success', response.data.message);
				updateCountOfAssignments();
			}
		).catch(
			(error) => {
				console.error('error updating assignment', {error});
				Toast.add('error', 'Bearbeiten des Einsatzes fehlgeschlagen.');
			}
		).then(
			() => updateContainers(teamId)
		).then(
			() => loadCandidates(true)
		);
	}

	function editAssignmentInternal(id) {
		showIndicator().then(
			() => axios.get(siteUrl(['next/api/ep/einsatz', id]))
		).then(
			(response) => ({
				assignment: response.data,
				allowedChanges: allowedChanges(response.data.status),
				remarkTemplates: RemarkTemplates
			})
		).then(
			(model) => ({model, html: EditAssignmentTemplate(model)})
		).then(
			({model, html}) => {
				modalEditAssignment.innerHTML = html;
				const validator = new FormValidator(
					modalEditAssignment.querySelector('form'),
					editAssignmentFormValidityChanged,
					[
						{
							type: 'name', selector: 'bemerkungen', fn: function (element) {
								const value = element.value.trim();
								if (modalEditAssignment.querySelector('input[name=aktion]:checked')?.value === 'einsatz-loeschen') {
									element.setCustomValidity(value === '' ? 'Bemerkungen sind ein Pflichtfeld' : '');
								} else {
									element.setCustomValidity('');
								}
							}
						}
					]
				);
				Modal.create(modalEditAssignment, {
					onConfirm: () => {
						updateAssigment(id, validator.getCurrentFormValue());
					}
				});
				return model;
			}
		).then(
			(model) => {
				const selected = modalEditAssignment.querySelector('input[name=aktion]:checked');
				if (selected) {
					updateEditAssignmentFormInternal(selected.value, model.assignment.status);
				}
			}
		).catch(
			(error) => {
				console.error('could not load assignment', {error});
				Toast.add('error', 'Einsatz-Daten konnten nicht geladen werden')
			}
		).finally(
			() => hideIndicator()
		)
	}

	function updateEditAssignmentFormInternal(mode, stateCode) {
		const activeKeys = filterRemarkTemplates(mode, stateCode).map(template => template.key);
		modalEditAssignment.querySelectorAll('button.remark').forEach(btn => {
			if (activeKeys.indexOf(btn.value) >= 0) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		});
		const formGroup = modalEditAssignment.querySelector('.form-group.bemerkungen');
		if (mode === 'absage-loeschen') {
			formGroup?.classList.add('hidden');
		} else {
			formGroup?.classList.remove('hidden');
		}

		const remarkHints = modalEditAssignment.querySelector('.remark-hints');
		if (activeKeys.length === 0) {
			remarkHints?.classList.remove('hidden');
		} else {
			remarkHints?.classList.add('hidden');
		}
		const required = modalEditAssignment.querySelector('.form-group.bemerkungen .required');
		if (activeKeys.length === 0) {
			required?.classList.add('hidden');
		} else {
			required?.classList.remove('hidden');
		}
	}

	function createInvitations(model) {
		const remarks = querySelect('textarea#invitation_remarks').value;

		let successCount = 0;
		const promises = Array.from(modalSendInvitations.querySelectorAll('input[name=assignment]:checked')).map(
			(check) => {
				const assignment = model.einsaetze.find(assignment => assignment.id == check.value);
				if (assignment) {
					const body  = {
						aktion: 'einladen',
						bemerkungen: remarks
					}
					return axios.put(siteUrl(['next/api/ep/einsatz', check.value]), body)
						.then(
							() => successCount++
						).catch(
							(error) => {
								console.error('could not send invitation', {error})
								Toast.add('error', `Einladung an ${assignment.user.firstname} ${assignment.user.name} konnte nicht verschickt werden.`)
							}
						);
				} else {
					Toast.add('error', `Einsatz-Daten für Einsatz #${check.value} nicht gefunden.`);
					return Promise.resolve()
				}
			}
		);

		return Promise.all(promises).finally(
			() => {
				updateContainers(teamId);
				loadCandidates(true);
				if (successCount > 0) {
					Toast.add('success', `${successCount} Einladungen verschickt.`)
				} else {
					Toast.add('warning', 'Keine Einladungen verschickt.')
				}
			}
		)
	}

	let selectedAssignments = 0;

	function sendInvitationsInternal() {
		selectedAssignments = 0;
		axios.get(siteUrl(['next/api/ep/team', teamId])).then(
			(response) => {
				const data = response.data.data;
				const model = {
					...data,
					einsaetze: data.einsaetze?.filter(item => item.status === 0) || []
				};
				return {model, html: SendInvitiationsTemplate(model)}
			}
		).then(
			({model, html}) => {
				modalSendInvitations.innerHTML = html;
				Modal.create(modalSendInvitations, {
					onConfirm: () => {
						createInvitations(model);
					}
				});
				updateModal();
			}
		);
	}

	function updateModal() {
		modalSendInvitations.querySelectorAll('[data-confirm-modal]').forEach(element => {
			element.disabled = selectedAssignments == 0
		})
	}

	return {
		toggleAssignment: function (event, id) {
			if (!cancelled) {
				handleToggleAssignment(event.target.checked, id, event);
			}
		},
		editAssignment: function (event, id) {
			event.preventDefault();
			if (!readonly) {
				editAssignmentInternal(id);
			}
		},
		showJudgeDetail: (event, id, name) => {
			event.preventDefault();
			const modalContainer = querySelect('#dialogWrDetail');
			detailModal = new WrDetailModal(id, name);
			detailModal.attach(modalContainer);
			Modal.create(modalContainer);
		},
		pageAssignments: (tab, offset) => {
			if (detailModal) {
				detailModal.pageAssignments(tab, offset);
			} else {
				console.warn('detail modal not defined');
			}
		},
		updateEditAssignmentForm: function (event, mode, stateCode) {
			updateEditAssignmentFormInternal(mode, stateCode);
		},
		setRemark(element, text) {
			element.value = text;
			element.dispatchEvent(new Event('blur'));
		},
		sendInvitations: function (event) {
			event.preventDefault();
			sendInvitationsInternal();
		},
		invertSelection: function (event) {
			event.preventDefault();
			let count = 0;
			modalSendInvitations.querySelectorAll('input[name=assignment]').forEach(check => {
				check.checked = !check.checked;
				if (check.checked) {
					count++;
				}
			});
			selectedAssignments = count;
			updateModal();
		},
		updateSelection: function (event) {
			if (event.target.checked) {
				selectedAssignments++;
			} else {
				selectedAssignments--;
			}
			updateModal();
		}
	}
}

module.exports = EinsatzPlaner;
